import $ from 'jquery';
import Cookies from 'js-cookie';

const $cookiebar = $('.js-cookiebar');
const $cookiebarButton = $cookiebar.find('.js-cookiebar-button');
const cookiebarCookieName = `anndore-cookiebar`;
const cookiebarCookieDuration = 30 * 6; // days

function cookiebarShow() {
  $cookiebar.addClass('is-visible');
}

function cookiebarHide() {
  Cookies.set(cookiebarCookieName, true, {
    expires: cookiebarCookieDuration,
  });
  $cookiebar.removeClass('is-visible');
}

// Show cookiebar if cookie missing/expired
if ($cookiebar.length && !Cookies.get(cookiebarCookieName)) {
  cookiebarShow();
}

// Hide when clicking button
$cookiebarButton.on('click', cookiebarHide);
